import { Outlet, useLocation } from "react-router-dom";
import { ErrorPage } from "../../error";
import { SubscriptionService } from "../../../services";
import { router, routes } from "../../../app/routes";
import { PageTitleProvider, useAsync, useUrlParams  } from "../../../hooks";
import { BreadcrumbProps, SidebarSubmenu } from "../../../components";
import { useEffect, useState } from "react";
import generateHostBreadcrumbs from "./HostBreadcrumbs";
import PageLayout, { PageBreadcrumbProps } from "../../PageLayout";
import SubscriptionTopbar from "./SubscriptionTopbar";

function BaseLayout() {
  const subscriptionId = parseInt(useUrlParams("id"));
  const location = useLocation();
  const [breadcrumbs, setBreadcrumbs] = useState<PageBreadcrumbProps>();
  
  const subscriptionService = new SubscriptionService();
  const { value: subscriptionData, loading: subscriptionLoading, error: subscriptionError }
    = useAsync(() => subscriptionService.get(subscriptionId), [subscriptionId]);

  useEffect(() => {
      const newBreadcrumbs:BreadcrumbProps = generateHostBreadcrumbs(location.pathname,undefined,"", subscriptionId, subscriptionData?.name);
      setBreadcrumbs(newBreadcrumbs);
  
  }, [location.pathname, subscriptionId, subscriptionData])

  if(subscriptionLoading) return <></>
  if(subscriptionError){
    return <ErrorPage message={subscriptionError.message} />
  }

  return (
    <PageLayout title={`Subscription: ${subscriptionData?.name ?? ""}`} topbar={<SubscriptionTopbar/>} breadcrumbs={breadcrumbs}>
      <div className="row">
          <Outlet />
      </div>
    </PageLayout>
  )
}

export function SubscriptionLayout() {
  // Wrap the BaseUserLayout in a PageTitleProvider.
  // This prevents an error of the context not being initialized when the usePageTitle hook is called.

  return (
    <PageTitleProvider>
      <BaseLayout />
    </PageTitleProvider>
  );
}

export default SubscriptionLayout
